// Live "thinking" display: shows streaming tokens and status during generation.

import React from "react";

export interface ThinkingState {
  active: boolean;
  status: string;
  text: string;
  unit?: { index: number; total: number; title: string };
}

export function ThinkingPanel({ state }: { state: ThinkingState }) {
  const ref = React.useRef<HTMLPreElement | null>(null);
  React.useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [state.text]);

  if (!state.active && !state.text) return null;

  return (
    <div className="card" style={{ background: "#0f1020", color: "#e6e6f0" }}>
      <div className="row-between" style={{ marginBottom: 8 }}>
        <strong style={{ color: "#c9c6f0" }}>
          {state.active ? "🧠 Thinking…" : "🧠 Generation log"}
        </strong>
        {state.unit && (
          <span className="muted" style={{ color: "#8b8ab5" }}>
            Unit {state.unit.index}/{state.unit.total}: {state.unit.title}
          </span>
        )}
      </div>
      {state.status && (
        <div style={{ color: "#8be0b0", fontSize: 13, marginBottom: 6 }}>{state.status}</div>
      )}
      <pre
        ref={ref}
        style={{
          maxHeight: 260,
          overflow: "auto",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontFamily: "ui-monospace, monospace",
          fontSize: 12.5,
          margin: 0,
          lineHeight: 1.5,
        }}
      >
        {state.text || (state.active ? "…" : "")}
        {state.active && <span className="cursor">▋</span>}
      </pre>
    </div>
  );
}
